export default __webpack_public_path__ + "static/media/keyboard_arrow_up.d678da74.svg";